import { AnalyticsBrowser } from '@segment/analytics-next/dist/cjs'
import { getWhitelabelGroup, convertDynamicFormValuesForTracking } from '@/utils/utils'

const whiteLabelId = getWhitelabelGroup()

let analytics = null
const enableLogging = import.meta.env.VITE_SEGMENT_LOGGING === 'true'

const sensitiveFields = ['password', 'confirmPassword']
const isSensitiveField = fieldName => sensitiveFields.includes(fieldName)

if (import.meta.env.VITE_SEGMENT_API_KEY) {
  try {
    analytics = AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_API_KEY })
  } catch (error) {
    console.log('Segment Initialization failed:', error)
  }
}

const formatConsoleMessage = (type, details) => {
  console.info(`${type} event fired`, details)
}

export const trackPage = (pageName, pageProperties = {}) => {
  if (enableLogging) {
    formatConsoleMessage(
      'Track page',
      `
      Page name: ${pageName}
      Event Data: ${JSON.stringify(pageProperties, null, 2)}
    `
    )
  }
  if (analytics) {
    analytics.page(pageName, { ...pageProperties, whiteLabel: whiteLabelId })
  }
}

export const trackEvent = (eventName, eventProperties = {}) => {
  const transformedProperties = Object.keys(eventProperties).reduce((acc, key) => {
    const fieldValue = eventProperties[key]
    const safeValue = isSensitiveField(key) ? '********' : fieldValue
    acc[key] = convertDynamicFormValuesForTracking(key, safeValue)

    return acc
  }, {})

  if (enableLogging) {
    formatConsoleMessage(
      'Track event',
      `
      Event name: ${eventName}
      Event Data: ${JSON.stringify(transformedProperties, null, 2)}
    `
    )
  }

  if (analytics) {
    analytics.track(eventName, { ...transformedProperties, whiteLabel: whiteLabelId })
  }
}

export const trackFormEvent = (eventName, fieldName, fieldValue, additionalProperties = {}) => {
  const safeFieldValue = isSensitiveField(fieldName) ? '********' : fieldValue

  if (enableLogging) {
    formatConsoleMessage(
      'Track form event',
      `
      Event name: ${eventName}
      Field name: ${fieldName}
      Field value: ${safeFieldValue}
      Additional: ${JSON.stringify(additionalProperties, null, 2)}
    `
    )
  }
  if (analytics) {
    analytics.track(eventName, { ...additionalProperties, fieldName, fieldValue: safeFieldValue, whiteLabel: whiteLabelId })
  }
}

export const trackIdentity = (userId, userProperties = {}) => {
  if (enableLogging) {
    formatConsoleMessage(
      'Identify user',
      `
      UserId: ${userId}
      Event Data: ${JSON.stringify(userProperties, null, 2)}
    `
    )
  }
  if (analytics) {
    analytics.identify(userId, { ...userProperties, whiteLabel: whiteLabelId })
  }
}

export default function useSegmentAnalytics() {
  return {
    trackPage,
    trackEvent,
    trackFormEvent,
    trackIdentity
  }
}
